import request from '@/utils/request'

export function selectList ({ type, params }) {
  return request({
    url: '/api/videosort/' + type,
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/API/list.js